
import { defineComponent, ref } from "vue";
import { hideModal } from "@/core/helpers/dom";
export default defineComponent({
  name: "modalDeleteAndReason",
  props: {
    html: String,
    title: String,
  },
  methods: {
    showModal() {
        this.view_template_mail?.click()
    },
    closeModal() {
        hideModal(this.createAppModalRef)
    },
  },
  setup() {
    const createAppModalRef = ref<null | HTMLElement>(null);
    const view_template_mail = ref<null | HTMLElement>(null);
    
    return {
        createAppModalRef,
        view_template_mail,
    }
  }
  });
